import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M1.503 14.5h1.924a.5.5 0 1 0 0-1.001H2.78l1.372-.934 3.078 1.778a.502.502 0 0 0 .5 0l3.066-1.772 1.236.861h-.458a.5.5 0 0 0 0 1.001h1.93a.5.5 0 0 0 .5-.5v-1.927a.5.5 0 1 0-1 0v.884l-1.41-.983a.49.49 0 0 0 .026-.097V7.606a.5.5 0 0 0-.25-.434l-3.395-1.96V3.71l.51.51a.5.5 0 1 0 .707-.71L7.827 2.146a.5.5 0 0 0-.706 0L5.758 3.509a.5.5 0 0 0 .707.708l.509-.51v1.51L3.591 7.171a.5.5 0 0 0-.25.433v4.204a.524.524 0 0 0 .022.083L2 12.818v-.747a.5.5 0 0 0-1 0v1.928a.501.501 0 0 0 .503.501Zm6.471-8.133 2.643 1.527v3.337L7.974 9.389V6.367Zm-.461 3.919 2.376 1.655-2.41 1.393-2.408-1.391 2.442-1.657ZM4.34 7.894l2.633-1.522v3.07L4.341 11.23V7.894Z';
const draw24px =
  'M2.9 21.069h2.887a.75.75 0 1 0 0-1.5h-.973l2.059-1.4 4.616 2.665a.753.753 0 0 0 .75 0l4.6-2.656 1.854 1.291h-.687a.75.75 0 1 0 0 1.5H20.9a.75.75 0 0 0 .75-.75v-2.887a.75.75 0 1 0-1.5 0v1.324l-2.114-1.472a.75.75 0 0 0 .039-.146v-6.3a.748.748 0 0 0-.375-.649L12.607 7.15V4.9l.764.764A.752.752 0 0 0 14.432 4.6l-2.045-2.042a.75.75 0 0 0-1.06 0L9.283 4.6a.75.75 0 0 0 1.06 1.061l.764-.764v2.261l-5.074 2.93a.75.75 0 0 0-.375.649v6.3a.783.783 0 0 0 .033.124l-2.045 1.388v-1.12a.75.75 0 1 0-1.5 0v2.89a.75.75 0 0 0 .754.75Zm9.707-12.187 3.964 2.288v5l-3.964-2.76V8.882Zm-.692 5.872 3.564 2.481-3.615 2.087-3.611-2.085 3.662-2.483ZM7.158 11.17l3.949-2.28v4.6l-3.949 2.678V11.17Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SectionAnalysisIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'sectionAnalysis')) as IconWithRender;

SectionAnalysisIcon.displayName = 'SectionAnalysisIcon';
SectionAnalysisIcon.propTypes = Icon.propTypes;
SectionAnalysisIcon.renderIcon = (props) => <SectionAnalysisIcon {...props} />;
export default SectionAnalysisIcon;
